import Hero from "./components/Hero";

export default function Home() {
  return (
    <main className="min-h-screen bg-[#050717]">
      <Hero />
    </main>
  );
}